module.exports = __webpack_public_path__ + "static/media/bg-a.4bec0579.png";